<template>
  <span :class="['chip-container', { active: isActive }]" @click="handleClick">
    {{ text }}
  </span>
</template>


<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>


<style src="./styles.css"></style>
